import { getFrontendCustomField } from "../frontendCustomFields"
import { 
  getLocalizedDateLabel, 
  getNextPaymentDateAfterPurchase, 
  getOfferWeeks,
  getOfferMonths,
} from "../helpers"
import { generateUpsellPageUrl, getUpsellOffers } from "../upsells"

export default () => ({
  tyPageTrialVersion: getFrontendCustomField({
    pipelineConfig,
    fieldName: 'tyPageTrialVersion'
  }),

  init() {
    this.commonInit()
  },

  commonInit() {
    this.store = Alpine.store("data")

    // Save purchased basic offer, as active offer will be overwritten during upsells
    this.store.savePurchasedBasicOffer()

    window.addEventListener("pageshow", () => {
      this.store.trackStatusForAnalytics("PURCHASE")
    })

    const data = { segmentUserId: this.store.values.segmentUserId || "" }
    this.store.internalTracker.isUserIdentified(data).then((isIdentified) => {
      if (!isIdentified) {
        this.store.internalTracker.trackIdentify({
          customData: {
            email: this.store.values.email,
            segmentUserId: this.store.values.segmentUserId,
          },
        })
      }
    })
  },

  proceed() {
    this.store.internalTracker.trackClick({ clickName: "Continue Clicked" })
    const upsellOffers = getUpsellOffers(pipelineConfig.offers)

    // No upsells provided
    if (upsellOffers.length === 0) {
      this.store.goToLogin()
      return
    }

    // Proceed to upsells starting from the first defined by products
    const firstUpsell = upsellOffers[0]

    const firstUpsellOfferUrl = generateUpsellPageUrl({
      upsellOfferType: firstUpsell.type
    })

    window.location = firstUpsellOfferUrl
  },

  getPaidPrice() {
    return this.store.pricing.getPrice({
      offer: this.store.values.activeOffer,
      isChance: this.store.values.exitIntent,
    })
  },

  getFuturePrice() {
    const offer = this.store.values.activeOffer
    const isChance = this.store.values.exitIntent

    return this.store.pricing.getFuturePrice({
      offer,
      isChance
    })
  },

  getFuturePricePerPeriod() {
    const offer = this.store.values.activeOffer
    const isChance = this.store.values.exitIntent

    return this.store.pricing.getFuturePricePerPeriod({
      offer,
      isChance
    })
  },

  getNextPaymentDateAfterPurchase() {
    const futureDate = getNextPaymentDateAfterPurchase(this.store.values.activeOffer)

    return getLocalizedDateLabel(futureDate)
  },
  
  getPriceDiscount () {
    const offer = this.store.values.activeOffer
    const isChance = this.store.values.exitIntent
    
    return this.store.pricing.getPriceDiscount({
      offer,
      isChance
    })
  },

  isOfferTrial() {
    return this.store.pricing.isOfferTrial(this.store.values.activeOffer)
  },

  //
  
  getOfferMonths(offer = this.store.values.activeOffer) {
    return getOfferMonths(offer)
  },

  isOfferMultipleMonths(offer = this.store.values.activeOffer) {
    return getOfferMonths(offer) > 1
  },

  //

  getOfferWeeks(offer = this.store.values.activeOffer) {
    return getOfferWeeks(offer)
  },
  
  isOfferMultipleWeeks(offer = this.store.values.activeOffer) {
    return getOfferWeeks(offer) > 1
  },
})
